import * as React from 'react';
import {IconGenerator, IconProps} from './IconGenerator';

export const CheckIcon = (props: IconProps) => (
  <IconGenerator viewBox='0 0 16 12' body={<path d='M1 5L6 10L15 1' stroke={props.color} strokeWidth='2' />} {...props} color='transparent' />
);
